import styled from 'styled-components'

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Container = (styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
